<template>
  <div v-if="isMaxScreen">
    <Head></Head>
    <div class="pc_pre-price">
      <div style="flex: 1; overflow-y: auto; height: 100%">
        <PC-order-step></PC-order-step>
        <PC-bread-nav></PC-bread-nav>
        <div class="device-main">
          <div class="device-item">
            <PC-device-info :data="data" :moneyData="data"></PC-device-info>
            <PC-model-info ref="propertyList" :moneyData="data"></PC-model-info>
          </div>
        </div>
      </div>
    </div>
    <PC-bottom-button @handleSubmit="submit" :data="data"></PC-bottom-button>
  </div>
  <div class="pre-price" v-else>
    <h-head></h-head>
    <PC-order-step></PC-order-step>
    <!-- <common-header :title="$route.meta.title" @goBack="goBack"></common-header> -->
    <div class="pre-main">
      <priceCard
        :title="data.skuName"
        :price="data.evaluation"
        :symbol="data.currencySymbol"
        :subsidy="data.bonus"
        :expertDiscount = "data.expertDiscount"
      />

      <footer>
        <van-button
          class="btn-active"
          @click="submit"
          :loading="loading"
          :loading-text="$t('PCBottomButton.index.647hqss76dg0')"
          loading-type="spinner"
          >{{ $t('PCBottomButton.index.647hqss76dg0') }}</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import priceCard from './components/priceCard.vue';
import { mapState } from 'vuex';
import Head from '../../components/head';
import hHead from '@/components/layout/head.vue';
import PCBreadNav from '@/components/PCBreadNav';
import PCOrderStep from '@/components/PCOrderStep';
import PCDeviceInfo from './components/PCDeviceInfo';
import PCModelInfo from './components/PCModelInfo';
import PCBottomButton from '@/components/PCBottomButton';
export default {
  name: 'Evaluate',
  components: {
    priceCard,
    Head,
    PCBreadNav,
    PCOrderStep,
    PCDeviceInfo,
    PCModelInfo,
    PCBottomButton,
    hHead
  },
  data() {
    return {
      data: {
        skuName: '',
        evaluation: 0,
        categoryId: ''
      },
      isActive: false,
      dataList: [],
      activeMoney: {},
      loading: false
    };
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  created() {
    this.data = JSON.parse(this.$route.query.data);
    console.log(this.data)
    this.lang = sessionStorage.getItem('lang') || 'es';
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    submit() {
      this.$router.push({
        name: 'SettleAccount',
        query: {
          data: JSON.stringify(this.data),
          id: this.$route.query.id
        }
      });
      return;
      let appToDhQuery = {};
      try {
        appToDhQuery = window.localStorage.getItem('appToDhQuery')
          ? JSON.parse(window.localStorage.getItem('appToDhQuery'))
          : {};
        console.log('appToDhQuery', appToDhQuery);
      } catch (e) {}
      if (
        appToDhQuery.orderId &&
        appToDhQuery.orderId == window.localStorage.getItem('jsydCreatedOrderId')
      ) {
        this.$toast(this.$t('tip.tip36')); // 如果需要重新下单请关闭/退出此页面重新进入
        return;
      }

      const queryData = JSON.parse(this.$route.query.data);
      let type = JSON.parse(sessionStorage.getItem('type'));
      let data = {
        imei,
        // 以下参数路由获取
        evaluationId: queryData.evaluationId,
        optionIds: queryData.optionIds,
        productId: queryData.productId,
        skuId: queryData.skuId,
        type
      };
      if (appToDhQuery.orderId) {
        data.thirdOrderNum = appToDhQuery.orderId;
      }
      if (appToDhQuery.crmId) {
        data.crmId = appToDhQuery.crmId;
      }
      if (appToDhQuery.region) {
        data.region = appToDhQuery.region;
      }

      // 注意增加必填校验
      this.$api['createOrder'](data)
        .then(res => {
          if (res.code === '0000') {
            // 创建订单成功
            console.log(res);
            if (appToDhQuery.orderId) {
              window.localStorage.setItem('jsydCreatedOrderId', appToDhQuery.orderId);
            }

            this.$router.push({
              name: 'uploadPhoto',
              query: {
                imei: imei,
                orderNum: res.data.orderNum,
                orderCreated: res.data.orderTime,
                productName: res.data.productName,
                skuId: queryData.skuId,
                spuId: res.data.spuId,
                brandId: this.data.brandId,
                categoryId: this.data.categoryId,
                fold: this.$route.query.fold || null
              }
            });

            // 填写IMEI 提交成功埋点
            if (isTestOrder()) {
              sendSensorsUserMessage('ThC2B_H5_GenerateOrderNo', {
                Th_model_name: res.data.productName,
                Th_order_id: res.data.orderNum
              });
            }
          } else {
            this.$toast(res.message);
          }
        })
        .catch(err => {
          this.$toast(err.message);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.pre-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  // min-height: 100vh;
  background: #f5f5f5;
  margin-top: 88px;
  .pre-main {
    width: 100%;
    padding: 34px 24px;
    box-sizing: border-box;

    .Vector {
      width: 32px;
      height: 32px;
      margin-right: 5px;
    }
    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 10px 24px !important;
      font-size: 28px;
      .btn-active {
        height: 80px;
        width: 100%;
        text-align: center;
        line-height: 80px;
        background: #ff8a14 !important;
        color: #fff !important;
        border-radius: 16px;
      }
    }

    .active {
      margin-top: 48px;
      // background-image: url(../../../assets/PC/img/activity-bg.png);
      background-image: url(../../assets/PC/img/h5-activity-bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 10px;
      overflow: hidden;
      padding: 0 24px;
      width: 100%;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      // height: 148px;

      .medium-div {
        display: flex;
        align-items: center;
        margin: 32px 0;
        color: #333;

        font-family: PoetsenOne;
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        img {
          height: 44px;
        }
      }

      .active-info {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        img {
          width: 100%;
        }

        // justify-content: space-between;
        .active-item {
          // width: 394px;
          // height: 82px;
          width: 100%;
          // height: 164px;
          // padding: 0 24px;
          border-radius: 6px;
          border-radius: 12px;
          background: rgba(255, 241, 228, 0.6);
          // background: rgba(255, 241, 228, 0.6);
          margin-bottom: 24px;
          display: flex;
          margin-right: 10px;
          align-items: center;
          // padding: 10px 20px;
          // border: 1px solid #e0e0e0;
          cursor: pointer;
          img {
            width: 84px;
            height: 104px;
            margin: 0 20px;
          }
          .active-item-title {
            color: var(--text-1, #252629);
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin-top: 24px;
            display: block;
          }
          .active-item-content {
            color: var(---Text-2, var(---Text-2, #5d5f65));
            font-family: 'PingFang SC';
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            display: block;
            margin-top: 8px;
            margin-bottom: 24px;
          }
          .marR40 {
            margin-right: 40px;
          }
        }
        .active-item:nth-child(2n) {
          margin-right: 0;
        }
        .disabled {
          color: #ccc;
          pointer-events: none;
        }
        .current {
          border: 1px solid #ff8a14;
          color: #ff8a14;
          //background-color: #FFF2E5;
        }
      }
    }
  }
}

@media (min-width: 981px) {
  .pc_pre-price {
    background-color: #f8f8f8;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 1200px;
    margin: 100px auto 150px;
    .device-main {
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      .device-item {
        width: 1200px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
